import styled from "@emotion/styled"

export const BlockItemIntegerStyles = styled.div`
    margin-bottom: 20px;
`
